module.exports = __webpack_public_path__ + "img/vital_new.68f38800.png";